module.exports = __webpack_public_path__ + "img/buettner_mpp_170.414c74eb.png";